import CheckoutPrivateCustomerInfo from '../Checkout.PrivateCustomerInfo';
import CheckoutBusinessCustomerInfo from '../Checkout.BusinessCustomerInfo';
import { translate } from '../../Services/translation';
import React from 'react';
import PropTypes from 'prop-types';

const RenderCustomerDetailsSection = ({
  checkout,
  onCustomerDetailsChange,
  setOrderNote,
  constants
}) => {
  const { payload, errors = {} } = checkout;
  const {
    orderNote,
    authenticated,
    customerDetails,
    isBusinessCustomer,
    checkoutMode,
    companyAddresses,
    b2BCheckoutInfo,
    loginUrl,
  } = payload;
  const privateCustomerInfoComponent = (
    <CheckoutPrivateCustomerInfo
      {...{
        customerDetails,
        onChange: onCustomerDetailsChange,
        errors,
      }}
    />
  );
  const businessCustomerInfoComponent = (
    <CheckoutBusinessCustomerInfo
      {...{
        orderNote,
        companyAddresses,
        setOrderNote,
        customerDetails,
        authenticated,
        onChange: onCustomerDetailsChange,
        checkout,
      }}
    />
  );

  let body;
  if (!authenticated) {
    body = (
      <>
        {!isBusinessCustomer && checkoutMode === constants.checkoutMode.both && (
          <a href={loginUrl} className="checkout__link">
            {translate('checkout.customerinfo.already_customer_sign_in')}
          </a>
        )}
        {!isBusinessCustomer &&
          checkoutMode !== constants.checkoutMode.companyCustomers &&
          privateCustomerInfoComponent}
        {(isBusinessCustomer ||
          checkoutMode === constants.checkoutMode.companyCustomers) &&
          businessCustomerInfoComponent}
      </>
    );
  } else {
    if (isBusinessCustomer) {
      body = (
        <>
          <div
            className="container"
            dangerouslySetInnerHTML={{
              __html: b2BCheckoutInfo,
            }}
          ></div>
          {authenticated && businessCustomerInfoComponent}
        </>
      );
    } else {
      body = privateCustomerInfoComponent;
    }
  }
  return (
    <>
      <h3 className="checkout__section-title">
        {translate('checkout.customerinfo.title')}
      </h3>
      {body}
    </>
  );
};

RenderCustomerDetailsSection.propTypes = {
  checkout: PropTypes.object.isRequired,
  onCustomerDetailsChange: PropTypes.func.isRequired,
  setOrderNote: PropTypes.func.isRequired,
};

export default RenderCustomerDetailsSection;
